const launch = {
  path: 'launch',
  component: resolve => require(['@/pages/admin/reviewed/wechat/launch'], resolve),
  meta: {isLaunch: true}
}

export default launch
